export const homeRoute = () => '/'
